import { Loader } from "@brexhq/component-library";
import { Text } from "@brexhq/metal-text";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

const LoadingPage = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100vh",
  gap: "10px",
  flexDirection: "column",
});

const RedirectLoadingPage = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "500px",
  gap: "10px",
  flexDirection: "column",
});

export const Loading: React.FC = () => {
  return (
    <LoadingPage>
      <Loader />
    </LoadingPage>
  );
};

export const LongWaitLoading: React.FC = () => {
  const [showWaitText, setShowWaitText] = useState(false);
  useEffect(() => {
    setInterval(() => {
      setShowWaitText(true);
    }, 2000);
  }, []);
  return (
    <LoadingPage>
      {showWaitText && <Text variant={"BodySmallR"}>Give us a moment...</Text>}
      <Loader />
    </LoadingPage>
  );
};

export const RedirectLoading: React.FC = () => {
  return (
    <RedirectLoadingPage>
      <Text variant={"BodySmallR"}>Redirecting, give us a moment...</Text>
      <Loader />
    </RedirectLoadingPage>
  );
};
